import api from '../api'

export const postFertilization = ({ state, ...params }) =>
  api.post(`/farms/properties/activities/fertilizers/${ state }`, params)

export const putFertilization = ({ id, state, ...params }) =>
  api.put(
    state === 'plans'
      ? `/farms/properties/activities/fertilizers/plans/${ id }/updated`
      : `/farms/properties/activities/fertilizers/plans/${ id }/completed`,
    params
  )

export const deleteFertilization = ({ id }) => api.delete(`/farms/properties/activities/fertilizers/${ id }`)

export const postHarvest = ({ state, ...params }) =>
  api.post(`/farms/properties/activities/harvests/${ state }`, params)

export const putHarvest = ({ id, state, ...params }) =>
  api.put(
    state === 'plans'
      ? `/farms/properties/activities/harvests/plans/${ id }/updated`
      : `/farms/properties/activities/harvests/plans/${ id }/completed`,
    params
  )

export const deleteHarvest = ({ id }) => api.delete(`/farms/properties/activities/harvests/${ id }`)

export const postPesticideApplication = ({ state, ...params }) =>
  api.post(`/farms/properties/activities/insecticides/${ state }`, params)

export const putPesticideApplication = ({ id, state, ...params }) =>
  api.put(
    state === 'plans'
      ? `/farms/properties/activities/insecticides/plans/${ id }/updated`
      : `/farms/properties/activities/insecticides/plans/${ id }/completed`,
    params
  )

export const deletePesticideApplication = ({ id }) => api.delete(`/farms/properties/activities/insecticides/${ id }`)

export const postSeeding = ({ state, ...params }) =>
  api.post(`/farms/properties/activities/plantations/${ state }`, params)

export const putSeeding = ({ id, state, ...params }) =>
  api.put(
    state === 'plans'
      ? `/farms/properties/activities/plantations/plans/${ id }/updated`
      : `/farms/properties/activities/plantations/plans/${ id }/completed`,
    params
  )

export const deleteSeeding = ({ id }) => api.delete(`/farms/properties/activities/plantations/${ id }`)

export const postSoilPreparation = ({ state, ...params }) =>
  api.post(`/farms/properties/activities/soil-preparations/${ state }`, params)

export const putSoilPreparation = ({ id, state, ...params }) =>
  api.put(
    state === 'plans'
      ? `/farms/properties/activities/soil-preparations/plans/${ id }/updated`
      : `/farms/properties/activities/soil-preparations/plans/${ id }/completed`,
    params
  )

export const deleteSoilPreparation = ({ id }) => api.delete(`/farms/properties/activities/soil-preparations/${ id }`)
